<div class="apps-book-widget-mobile">
  <div class="mobile-container-row-1">
    <div class="mobile-container-row-1__item airports-field">
      <idp-one-way-route-picker
        [routePickerContent]="{
          origin: {
            title:
              bookWidgetFields.airportsField.airports[0].fromAirportcode ||
              bookWidgetAem.airportsField.from,
            subtitle:
              bookWidgetFields.airportsField.airports[0].fromCity ||
              bookWidgetAem.airportsField.yourOrigin
          },
          destination: {
            title:
              bookWidgetFields.airportsField.airports[0].toAirportcode ||
              bookWidgetAem.airportsField.to,
            subtitle:
              bookWidgetFields.airportsField.airports[0].toCity ||
              bookWidgetAem.airportsField.yourDestination
          },
          ariaLabels: {
            origin:
              bookWidgetAem.airportsField.originAriaLabel +
              (bookWidgetFields.airportsField.airports[0].fromAirportcode.length
                ? ' ' +
                  bookWidgetFields.airportsField.airports[0].fromAirportcode +
                  ', ' +
                  bookWidgetFields.airportsField.airports[0].fromCity
                : ''),
            swapArrow: bookWidgetAem.airportsField.swapAriaLabel,
            destination:
              bookWidgetAem.airportsField.destinationAriaLabel +
              (bookWidgetFields.airportsField.airports[0].toAirportcode.length
                ? ' ' +
                  bookWidgetFields.airportsField.airports[0].toAirportcode +
                  ', ' +
                  bookWidgetFields.airportsField.airports[0].toCity
                : '')
          }
        }"
        [routePickerCities]="{
          destinationCode:
            bookWidgetFields.airportsField.airports[0].toAirportcode,
          destinationName: bookWidgetFields.airportsField.airports[0].toCity,
          destinationRegion: '',
          originCode:
            bookWidgetFields.airportsField.airports[0].fromAirportcode,
          originName: bookWidgetFields.airportsField.airports[0].fromCity,
          originRegion: ''
        }"
        [routePickerError]="
          bookWidgetFields.airportsField.fieldErrorInfo?.routePickerField
        "
        [recentSearchList]="recentSearchList"
        [savedSearchList]="savedSearchList"
        [searchModalTabs]="searchModalTabs"
        [isFullscreen]="isFullscreen"
        [predictiveSearchData]="predictiveSearchData"
        (searchModalTriggerClicked)="searchModalTriggerClicked.emit($event)"
        (swapClicked)="swapClicked.emit(0)"
        (searchModalEvent)="searchModalEvent.emit($event)"
      ></idp-one-way-route-picker>
    </div>
    <div class="mobile-container-row-1__item trip-type-field">
      <mach-select
        id="trip-type-field"
        [title]="''"
        [content]="bookWidgetFields.tripTypesField.dropdownOptions"
        [disabled]="bookWidgetFields.tripTypesField.disable"
        (action)="
          onDropdownSelectionChange($event, bookWidgetFieldUpdateTypes.tripType)
        "
        [icon]="{
          alt: '',
          src:
            bookWidgetFields.tripTypesField.selectedTripType ===
            tripTypeOptions.ONE_WAY
              ? '/content/dam/delta-applications/sitewide/capability/flight-shop/images/one-way.svg'
              : '/content/dam/delta-applications/sitewide/capability/flight-shop/images/trip-icon.svg',
          show: true
        }"
        [ariaLabel]="bookWidgetAem.tripTypesField.tripTypeAriaLabel"
      ></mach-select>
    </div>
    <div class="mobile-container-row-1__item dates-field">
      <idp-flight-date-picker
        [selectedTripType]="bookWidgetFields.tripTypesField.selectedTripType"
        [selectedRange]="bookWidgetFields.datesField.dates[0]"
        [bookWidgetAem]="bookWidgetAem"
        [datepickerConfig]="datepickerConfig"
        [fieldErrorInfo]="bookWidgetFields.datesField.fieldErrorInfo?.[0]"
        (action)="
          onDateSelectionChange(
            $event,
            bookWidgetFieldUpdateTypes.datesChange,
            0
          )
        "
      ></idp-flight-date-picker>
    </div>
    <div class="mobile-container-row-1__item passenger-field">
      <mach-select
        [title]="''"
        [content]="bookWidgetFields.passengerField.dropdownOptions"
        [disabled]="bookWidgetFields.passengerField.disable"
        (action)="
          onDropdownSelectionChange(
            $event,
            bookWidgetFieldUpdateTypes.passenger
          )
        "
        [icon]="{
          alt: bookWidgetAem.passengerField.passenger,
          src: '/content/dam/delta-applications/sitewide/capability/flight-shop/images/pax-icon.svg',
          show: true
        }"
        [ariaLabel]="bookWidgetAem.passengerField.passengerAriaLabel"
      ></mach-select>
    </div>
  </div>
  <div class="mobile-container-row-2">
    <div
      class="mobile-container-row-2__item show-miles-field"
      *ngIf="!bookWidgetFields.shopMilesField.hide"
    >
      <label
        class="field-label"
        for="bookWithMiles"
        [ngClass]="{
          'mach-checkbox-label-disabled':
            bookWidgetFields.shopMilesField.disable
        }"
      >
        {{ bookWidgetAem.shopMilesField.shopWithMiles }}
      </label>
      <mach-toggle
        id="bookWithMiles"
        [disabled]="bookWidgetFields.shopMilesField.disable"
        [selected]="bookWidgetFields.shopMilesField.checked"
        (toggled)="onToggleChange($event, bookWidgetFieldUpdateTypes.shopMiles)"
      ></mach-toggle>
    </div>
    <div
      class="mobile-container-row-2__item flex-dates-field"
      *ngIf="!bookWidgetFields.flexDatesField.hide"
    >
      <label
        class="field-label"
        for="flexDates"
        [ngClass]="{
          'mach-checkbox-label-disabled':
            bookWidgetFields.flexDatesField.disable
        }"
      >
        {{ bookWidgetAem.flexDatesField.flexDates }}
      </label>
      <mach-toggle
        id="flexDates"
        [selected]="bookWidgetFields.flexDatesField.checked"
        [disabled]="bookWidgetFields.flexDatesField.disable"
        (toggled)="onToggleChange($event, bookWidgetFieldUpdateTypes.flexDates)"
      ></mach-toggle>
    </div>
    <div
      class="mobile-container-row-2__item basic-fares-field"
      *ngIf="!bookWidgetFields.basicFaresField.hide"
    >
      <label
        class="field-label"
        for="basicFaresField"
        [ngClass]="{
          'mach-checkbox-label-disabled':
            bookWidgetFields.basicFaresField.disable
        }"
      >
        {{ bookWidgetAem.includeBasicField.includeBasic }}
      </label>
      <mach-toggle
        id="basicFaresField"
        [selected]="bookWidgetFields.basicFaresField.checked"
        [disabled]="bookWidgetFields.basicFaresField.disable"
        (toggled)="
          onToggleChange($event, bookWidgetFieldUpdateTypes.basicFares)
        "
      ></mach-toggle>
    </div>
    <div
      class="mobile-container-row-2__item refundable-fare-field"
      *ngIf="!bookWidgetFields.refundableFareField.hide"
    >
      <div class="refundable-fare-field-label-container">
        <label
          class="field-label"
          for="refundableFares"
          [ngClass]="{
            'mach-checkbox-label-disabled':
              bookWidgetFields.refundableFareField.disable
          }"
        >
          {{ bookWidgetAem.refundableFareField.refundableOnly }}
        </label>

        <img
          src="/content/dam/delta-applications/sitewide/capability/flight-shop/images/alert-icon-help.svg"
          [attr.aria-label]="
            bookWidgetAem.refundableFareField.refundableOnly +
            ' ' +
            bookWidgetAem.helpIconAriaLabel
          "
          role="button"
          tabindex="0"
          (click)="
            infoIconClickHandler(bookWidgetFieldInfoTypes.REFUNDABLE_FARE_ONLY)
          "
          (keypress)="
            $event.key === 'Enter' &&
              infoIconClickHandler(
                bookWidgetFieldInfoTypes.REFUNDABLE_FARE_ONLY
              )
          "
        />
      </div>
      <mach-toggle
        id="refundableFares"
        [selected]="bookWidgetFields.refundableFareField.checked"
        [disabled]="bookWidgetFields.refundableFareField.disable"
        (toggled)="
          onToggleChange($event, bookWidgetFieldUpdateTypes.refundableFare)
        "
      ></mach-toggle>
    </div>
    <div
      class="mobile-container-row-2__item flex-airports-field"
      *ngIf="!bookWidgetFields.flexAirportsField.hide"
    >
      <label
        class="field-label"
        for="flexAirport"
        [ngClass]="{
          'mach-checkbox-label-disabled':
            bookWidgetFields.flexAirportsField.disable
        }"
      >
        {{ bookWidgetAem.flexAirportsField.flexAirports }}
      </label>
      <mach-toggle
        id="flexAirport"
        [selected]="bookWidgetFields.flexAirportsField.checked"
        [disabled]="bookWidgetFields.flexAirportsField.disable"
        (toggled)="
          onToggleChange($event, bookWidgetFieldUpdateTypes.flexAirport)
        "
      ></mach-toggle>
    </div>
  </div>
  <div class="mobile-container-row-3">
    <div
      class="mobile-container-row-3__item best-fare-options-field"
      *ngIf="!bookWidgetFields.bestFareOptionsField.hide"
    >
      <idp-best-fare-options
        [bookWidgetAem]="bookWidgetAem"
        [bookWidgetFields]="bookWidgetFields"
        (bestFareOptionsChange)="
          onDropdownSelectionChange(
            $event,
            bookWidgetFieldUpdateTypes.bestFareOptions
          )
        "
        [toolTipPosition]="'top-right'"
      ></idp-best-fare-options>
    </div>
    <div
      class="mobile-container-row-3__item meeting-event-code-field"
      *ngIf="!bookWidgetFields.meetingEventCodeField.hide"
    >
      <idp-meeting-event-code
        [bookWidgetAem]="bookWidgetAem"
        [bookWidgetFields]="bookWidgetFields"
        (meetingEventCodeChange)="
          onInputFieldChange(
            $event,
            bookWidgetFieldUpdateTypes.meetingEventCode
          )
        "
        [toolTipPosition]="'top-right'"
      ></idp-meeting-event-code>
    </div>
    <a
      class="mobile-container-row-3__item edocs-link"
      *ngIf="!bookWidgetFields.edocsLink.hide"
      machLink
      [href]="bookWidgetFields.edocsLink.src"
      [linkSize]="'small'"
      [linkDisabled]="bookWidgetFields.edocsLink.disable"
      [innerHTML]="bookWidgetAem.edocsLink"
    ></a>
  </div>

  <div class="mobile-container-row-4">
    <button
      id="findFilghtsCta"
      class="mobile-container-row-4__item"
      machButton
      [buttonSize]="'large'"
      [buttonColor]="'primary'"
      [buttonOutlineColor]="'primary'"
      (click)="findFlightSubmit()"
    >
      {{ bookWidgetAem.searchBtn }}
    </button>
  </div>
</div>
